// extracted by mini-css-extract-plugin
module.exports = {"rectText":"Rects_rectText__jefwa","score":"Rects_score__sybvh","red":"Rects_red__1IeC4","blue":"Rects_blue__3zRnD","green":"Rects_green__L2PdY"};